<template>
    <div>
        <tsoft-table
            name="agent-withdrawal-request"
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="false"
            :additionalGetParameter="additionalGetParameter"
            :isNeedCreate="false"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Заявки на вывод средств по заданному фильтру отсутствуют. Попробуйте снова.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right-create-or-edit-agent-withdrawal-request"
            right
            backdrop
            shadow
            width="80em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <AgentWithdrawalRequestView 
                    :withdrawal-request="editedItem" 
                    :available-amount="0"
                    @request-updated="profileUpdated"
                    @close="isSidebarOpen=false"
                />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import {API_AGENT_WITHDRAWAL_REQUESTS} from "@/constants";
    import AgentWithdrawalRequestView from "@/components/agentWithdrawalRequests/AgentWithdrawalRequestView";

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem
    } from '@/mixins';

    const initialEditedItem = () => ({
        id: null,
        agent_company_id: null,
        amount: 0,
        status: 'pending',
        settlement_ids: [],
        created_by_user_id: null,
        processed_by_user_id: null,
        act_generated_at: null,
        act_sent_at: null,
        act_received_at: null,
        funds_sent_at: null,
        metadata: {},
        agent_company: {},
        creator: {},
        processor: {},
        documents: []
    })

    export default {
        components: {
            AgentWithdrawalRequestView
        },    
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionDeleteItem,
            actionCreateOrUpdateItem
        ],
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &agent_company_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: agentWithdrawalRequests
        },
        data() {
            return {
                loading: false,
                tableApiUrl: API_AGENT_WITHDRAWAL_REQUESTS,
                componentRefreshKey: 0,
                dataOverlay: false
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),

            isAgent() {
                return this.currentUser.role.includes('agent');
            },

            isClient() {
                return this.currentUser.role.includes('client');
            },
        },
        watch: {
        },
        mounted() {
            this.editedItem = initialEditedItem();
            this.initialAssign();
        },
        methods: {
            initialAssign() {
                // Инициализация данных
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem();
                this.initialAssign();
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            profileUpdated(data) {
                // If editIndex > -1 → update existing row; else → prepend new row
                if (this.editIndex > -1 && this.items && this.items.data && this.items.data[this.editIndex]) {
                    Object.assign(this.items.data[this.editIndex], data);
                } else if (this.items && this.items.data) {
                    this.items.data.unshift(data);
                }

                // Close sidebar and reset state
                this.onCreatedOrUpdatedCallback();
                this.editIndex = -1;
                this.validationErrors = '';
                this.makeToast('success');
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            modalTitle() {
                let title = 'Добавление заявки на вывод средств'
                if (this.editIndex > -1) {
                    title = 'Редактирование заявки на вывод средств #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            }
        }
    }
</script>

